import { mapStores } from 'pinia';
import { useWorldInfoStore } from '@/stores/worldInfo';
import { useNotificationStore } from '@/stores/notification';
import { useOrganizationStore } from '@/stores/organization';

export const commonPiniaStoresMixin = {
    mounted() {
    },
    computed: {
        // Mapped to this.worldInfoStore / this.notificationStore / this.organizationStore
        ...mapStores(useWorldInfoStore, useNotificationStore, useOrganizationStore),
    },

};
